import styled from '@emotion/styled';
import { ToastContainer } from 'react-toastify';

export const StyledToastContainer = styled(ToastContainer)`
    // https://fkhadra.github.io/react-toastify/how-to-style/

    .Toastify__toast {
        min-height: 58px;
    }

    .Toastify__toast-icon {
        align-self: flex-start;
        margin-top: 5px;
        margin-bottom: 5px;
    }
`;
